import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
export var CustomerType;
(function (CustomerType) {
    CustomerType["NotSet"] = "NotSet";
    CustomerType["Private"] = "Private";
    CustomerType["Business"] = "Business";
    CustomerType["SelfEmployed"] = "SelfEmployed";
})(CustomerType || (CustomerType = {}));
export var ProductType;
(function (ProductType) {
    ProductType["NotSet"] = "NotSet";
    ProductType["Loan"] = "Loan";
    ProductType["Leasing"] = "Leasing";
    ProductType["Limit"] = "Limit";
    ProductType["HomeEquityLOC"] = "HomeEquityLOC";
    ProductType["Unsecured"] = "Unsecured";
    ProductType["Service"] = "Service";
})(ProductType || (ProductType = {}));
export var ProductSelectorType;
(function (ProductSelectorType) {
    ProductSelectorType["NotSet"] = "NotSet";
    ProductSelectorType["Private"] = "Private";
    ProductSelectorType["Business"] = "Business";
    ProductSelectorType["Service"] = "Service";
    ProductSelectorType["Calculator"] = "Calculator";
})(ProductSelectorType || (ProductSelectorType = {}));
export var ProductCategory;
(function (ProductCategory) {
    ProductCategory["Finance"] = "Finance";
    ProductCategory["Service"] = "Service";
})(ProductCategory || (ProductCategory = {}));
export class ProductResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.name = "";
        this.externalCode = "";
        this.type = ProductType.NotSet;
        this.category = ProductCategory.Finance;
        this.active = false;
        this.wholesale = false;
        this.external = false;
        this.selectorType = ProductSelectorType.NotSet;
        this.dealerPortalId = -1;
    }
    pk() {
        return this.externalCode;
    }
    static list() {
        return super.list();
    }
}
ProductResource.urlRoot = apiResourceUrl("products");
ProductResource.urlTemplates = [
    `${ProductResource.urlRoot}/externalCode/{externalCode}`
];
//# sourceMappingURL=ProductResource.js.map